
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'PreviewBg',
})
export default class PreviewBg extends Vue {
    /** 图片链接 */
    @Prop({ type: String }) public src?: string;

    public onClick(e: MouseEvent) {
        if (this.src) {
            wx.previewImage({
                current: this.src,
                urls: [ this.src ],
            });
        }
        e.stopPropagation();
    }
}
